<div *ngIf="formGroup" class="EditSubscription py-3">
  <div class="EditSubscription-header mb-5">
    <h4 class="title__page">
      {{ state === 'edit' ? 'Edit Team Code' : 'Add new Team Code' }}
    </h4>
  </div>
  <div class="EditSubscription-form">
    <form [formGroup]="formGroup">
      <div class="EditSubscription-form-step">
        <div class="EditSubscription-form-step-form container">
          <div class="row">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Team Code"
                formControlName="team_code"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Initial Plan ID"
                formControlName="plan_id"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Plan cost"
                formControlName="plan_cost"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Trial days"
                formControlName="trial_days"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Coupon"
                formControlName="coupon_id"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Initial cost"
                formControlName="subscription_cost"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Credits"
                formControlName="credits"></app-text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="EditSubscription-form-step">
        <div class="EditSubscription-form-step-header">
          <h3>Set-1</h3>
        </div>
        <div class="EditSubscription-form-step-form container">
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Content code"
                formControlName="content_code"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Campaign Name"
                formControlName="campaign_name"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Contact group name"
                formControlName="user_contact_group"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <mat-label>Campaign type</mat-label>
              <mat-radio-group
                formControlName="campaign_type"
                (change)="onCampaignTypeChange($event, 'frequency')">
                <mat-radio-button
                  *ngFor="let item of campaignTypeItems"
                  [value]="item.value"
                  >{{ item.label }}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="EditSubscription-form-step">
        <div class="EditSubscription-form-step-header">
          <h3>Set-2</h3>
        </div>
        <div class="EditSubscription-form-step-form container">
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Content code"
                formControlName="content_code2"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Campaign name"
                formControlName="campaign_name2"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Contact group name"
                formControlName="user_contact_group2"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <mat-label>Campaign type</mat-label>
              <mat-radio-group
                formControlName="campaign_type2"
                (change)="onCampaignTypeChange($event, 'frequency2')">
                <mat-radio-button
                  *ngFor="let item of campaignTypeItems"
                  [value]="item.value"
                  >{{ item.label }}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="EditSubscription-form-step">
        <div class="EditSubscription-form-step-header">
          <h3>Set-3</h3>
        </div>
        <div class="EditSubscription-form-step-form container">
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Content code"
                formControlName="content_code3"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Campaign name"
                formControlName="campaign_name3"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Contact group name"
                formControlName="user_contact_group3"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-12">
              <mat-label>Campaign type</mat-label>
              <mat-radio-group
                formControlName="campaign_type3"
                (change)="onCampaignTypeChange($event, 'frequency3')">
                <mat-radio-button
                  *ngFor="let item of campaignTypeItems"
                  [value]="item.value"
                  >{{ item.label }}</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="EditSubscription-form-step">
        <div class="EditSubscription-form-step-form container">
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-select
                label="Billing Frequency"
                [items]="billingFrequencyItems"
                formControlName="billing_frequency"></app-select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Additional use cost"
                formControlName="additional_user_cost"></app-text-field>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col col-md-6">
              <app-text-field
                placeholder="Additional user plan"
                formControlName="additional_user_plan"></app-text-field>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="EditSubscription-buttons row">
      <div class="col col-12">
        <app-button
          class="EditSubscription-buttons-button"
          [size]="cancelButtonProperties.size"
          [color]="cancelButtonProperties.color"
          [route]="cancelButtonProperties.route"
          [text]="cancelButtonProperties.text"
          [style]="cancelButtonProperties.style"></app-button>
        <app-button
          class="EditSubscription-buttons-button"
          [size]="saveButtonProperties.size"
          [color]="saveButtonProperties.color"
          [Click]="saveButtonProperties.onClick"
          [text]="getButtonTitle()"
          [style]="saveButtonProperties.style"></app-button>
      </div>
    </div>
  </div>
</div>
